"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomInput = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var custom_input_1 = require("../styled/custom-input");

var CustomInput = function CustomInput(_a) {
  var placeholder = _a.placeholder,
      className = _a.className,
      currentLabel = _a.currentLabel,
      hasErrors = _a.hasErrors,
      id = _a.id,
      inFocus = _a.inFocus,
      disabled = _a.disabled,
      onClick = _a.onClick,
      _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'medium' : _b,
      leadingIcon = _a.leadingIcon,
      trailingIcon = _a.trailingIcon,
      ariaLabel = _a.ariaLabel,
      ariaExpanded = _a.ariaExpanded;
  (0, ui_helper_hooks_1.useOnKeyPress)('Enter', onClick, {
    isActive: inFocus
  });
  (0, ui_helper_hooks_1.useOnKeyPress)(' ', onClick, {
    isActive: inFocus
  });
  return react_1.default.createElement(custom_input_1.CustomInput, {
    type: "button",
    className: className,
    id: id,
    inFocus: inFocus,
    hasErrors: hasErrors,
    disabled: disabled,
    onClick: onClick,
    sizeOption: sizeOption,
    isTrailing: Boolean(trailingIcon),
    title: currentLabel || placeholder,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": "listbox"
  }, react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center"
  }, leadingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: leadingIcon,
    color: "grey-600",
    "aria-hidden": true,
    mr: 1
  }), placeholder && !currentLabel && react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption",
    color: "grey-600"
  }, placeholder), currentLabel && react_1.default.createElement(ui_text_1.Text, {
    pattern: "captionMedium"
  }, currentLabel)), react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center",
    ml: 1,
    mr: 2
  }, trailingIcon && react_1.default.createElement(ui_icon_1.Icon, {
    name: trailingIcon,
    color: "grey-600",
    "aria-hidden": true,
    mr: 2
  }), react_1.default.createElement(ui_icon_1.Icon, {
    name: "arrow-down",
    "aria-hidden": true,
    color: "grey-600",
    p: 0.25
  })));
};

exports.CustomInput = CustomInput;